//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import API from "~/api/api";
import aos from "~/mixins/aos.js";

export default {
  layout: "default-no-sticky",
  watch: {},
  mixins: [aos],
  data() {
    return {};
  },
  methods: {},

  head() {
    if (this.pageInfo) {
      let domain = "https://www.legalnature.com";
      let canonicalLink = domain + "/about-us";
      let meta = [
        { name: "description", content: this.metaInfo.description },
        { name: "keyword", content: this.metaInfo.keyword },
        { name: "og:image", content: this.metaInfo["og-image"] },
        { name: "og:title", content: this.metaInfo.title },
        { name: "og:description", content: this.metaInfo.description },
        { name: "og:type", content: "website" },
        { name: "og:url", content: canonicalLink },
      ];
      return {
        title: this.metaInfo.title,
        meta,
        link: [
          {
            rel: "canonical",
            href: canonicalLink,
          },
        ],
      };
    } else {
      return {};
    }
  },

  mounted() {},
  asyncData({ app, query, params, redirect, error }) {
    return Promise.all([
      API.butterPages.get(app.$axios, "about", {
        preview: query.preview ? 1 : 0,
      }),
    ])
      .then((results) => {
        const pageInfo = results[0];
        return {
          pageInfo,
          loading: false,
          error: false,
        };
      })
      .catch((e) => {
        console.error(e);
        error({ message: "Error fetching data..." });
        return {
          loading: false,
        };
      });
  },
  computed: {
    hero() {
      return this.pageInfo.fields.hero.table;
    },
    details() {
      return this.pageInfo.fields.quote.table;
    },
    quote() {
      return this.pageInfo.fields.quote.table;
    },
    team() {
      return this.pageInfo.fields.team.table;
    },
    mission() {
      return this.pageInfo.fields.mission.table;
    },
    map() {
      return this.pageInfo.fields.map.table;
    },
    two_items_cta() {
      return this.pageInfo.fields.two_items_cta.table;
    },
    metaInfo() {
      return this.pageInfo.fields.meta_information.table;
    },
  },
};
